module.exports = __webpack_public_path__ + "media/icons/close-a135e13e225c873e697c53c17098f62b.svg";